document.addEventListener("DOMContentLoaded", (event) => {

    const carousel = document.querySelectorAll('.services-2__group-1');

    if (carousel) {
        carousel.forEach(carousel_block => {

            const list = carousel_block.querySelector('.services-2__list');
            const next = carousel_block.querySelector('.services-2__next-btn') || null;
            const prev = carousel_block.querySelector('.services-2__prev-btn') || null;
            const nav_container = carousel_block.querySelector('.services-2__nav') || null;

            const swiper = new Swiper(list, {
                loop: true,
                loopPreventsSliding: true,
                autoplay: {
                    delay: 7500,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
                on: {
                    init: function () { toggleCustomNavigation(this, nav_container); },
                    resize: function () { toggleCustomNavigation(this, nav_container); },
                },
                slidesPerView: 1.15,
                spaceBetween: 22,
                autoHeight: true,
                breakpoints: {
                    440: {
                        slidesPerView: 1.2,
                        spaceBetween: 22,
                    },
                    500: {
                        slidesPerView: 2.2,
                        spaceBetween: 22,
                    },
                    748: {
                        slidesPerView: 3.2,
                        spaceBetween: 22,
                    },
                    991: {
                        slidesPerView: 3.5,
                        spaceBetween: 22,
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 22,
                    }
                }
            });

        });

        function toggleCustomNavigation(swiperInstance, nav_container) {
            if (swiperInstance.params.navigation && nav_container) {
                if (swiperInstance.slides.length <= swiperInstance.params.slidesPerView) {
                    nav_container.style.display = 'none';
                } else {
                    nav_container.style.display = 'flex';
                }
            }
        }
    }

});
